import { gql } from "@apollo/client";

export default gql`
  query findAllPlatformQuery($type: String!, $metaData: Object!){
    findAllPlatformQuery(type: $type, metaData: $metaData){
        success
        data
        code
        message
    }
}
`
